var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"call",class:_vm.callClasses},[(_vm.bid)?_c('BidDisplay',{attrs:{"bid":_vm.bid}}):_c('span',{class:_vm.type},[_vm._v(_vm._s(_vm.callText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }